import React, { Component, Suspense } from 'react';
import { Redirect, Route, Switch, NavLink } from 'react-router-dom';
import { Nav, Container, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { saveStateLogout } from '../../_helpers';
import {
  AppAside,
  AppHeaderDropdown
} from '@coreui/react';

// routes config
import routes from '../../routes';
const DefaultAside = React.lazy(() => import('./DefaultAside'));
const DefaultHeader = React.lazy(() => import('./DefaultHeader'));
const Footer = React.lazy(() => import('./Footer'));


class DefaultLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: []
    }

  }
  myFunction() {
    var sticky = document.getElementById("hd").offsetHeight;
    var header = document.getElementById("dp");

    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }

  }
  async componentDidMount() {
    // window.addEventListener('scroll', this.myFunction);

  }

  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>

  signOut(e) {
    e.preventDefault()
    localStorage.clear();
    this.props.setUser([])
    saveStateLogout()
    this.props.history.push('/login')
  }

  render() {

    return (
      <div className="app">

        <div className="app-body" style={{ marginTop: 0 }} >

          {/* ส่วนเมนู */}
          {/* <AppSidebar fixed display="lg">
            <AppSidebarHeader >
              <AppNavbarBrand
                full={{ src: logo, alt: 'CoreUI Logo' }}
                onClick={()=>console.log("555")
                }
              />
            </AppSidebarHeader>
            <AppSidebarForm />
            <Suspense>
              <AppSidebarNav navConfig={items} {...this.props} />
            </Suspense>
          </AppSidebar> */}

          {/* จอที่แสดงผล */}
          <main className="main">

            <div className="main-header">
              <Suspense fixed fallback={this.loading()}>
                <DefaultHeader {...this.props} />
              </Suspense>
            </div>

            <div className="div-slice"  >

              <Container fluid>
                <Suspense fallback={this.loading()}>
                  <Switch>
                    {routes.map((route, idx) => {
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props => (
                            <route.component {...props} />
                          )} />
                      ) : (null);
                    })}
                    <Redirect from="/" to="/home" />
                  </Switch>
                </Suspense>
              </Container>
            </div>

          </main>
          <AppAside fixed>
            <Suspense fallback={this.loading()}>
              <DefaultAside />
            </Suspense>
          </AppAside>
        </div >
        <Footer {...this.props} />
        {/* <AppFooter>
          <Suspense fallback={this.loading()}>
            <DefaultFooter />
          </Suspense>
        </AppFooter> */}
      </div >
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    user: state.user
  }
}

const mapDispatchtoProps = (dispatch) => {
  return {
    setUser: (data) => {
      console.log(data)
      dispatch({
        type: "setUserLogout",
        payload: data
      })
    }
  }
}

export default connect(mapStatetoProps, mapDispatchtoProps)(DefaultLayout);

